import { Flex, Heading, Text } from "@chakra-ui/react"
import React from "react"
import { SnapLogo } from "../../components/commons/SnapLogo"
import { SnapBg } from "../../components/snapBg"

export const ContactUsConfirmation = (): JSX.Element => (
  <SnapBg>
    <Flex align="center" justify="center" flexDir={"column"} p="16">
      <SnapLogo />
      <Heading color="white" mt="61px" fontSize={["48px", "48px", "48px", "60px", "60px"]}>
        Thanks for contacting us.
      </Heading>
      <Text color="white" py="9">
        Your form was successfully submitted.
      </Text>
    </Flex>
  </SnapBg>
)
